import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { TPVServices } from "../../../services";

/**
 * Generated class for the TpvTicketSelectedPersonsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tpv-ticket-selected-persons',
  templateUrl: 'tpv-ticket-selected-persons.html',
})
export class TpvTicketSelectedPersonsPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public tpvServices: TPVServices, ) {
  }

  ionViewDidLoad() {

  }

  updatePersons() {
    /*this.tpvServices.tableUpdatePersons(this.tpvServices.keyboard_screen);
    this.tpvServices.keyboard_screen = '';
    this.navCtrl.pop();*/
    if (this.tpvServices.keyboard_screen) {//que haya valor
      this.tpvServices.tableUpdatePersons(this.tpvServices.keyboard_screen);
      this.tpvServices.keyboard_screen = '';
      this.navCtrl.pop();
    } else {//no hay valor 
      //le ponemos valor anterior
      this.tpvServices.tableUpdatePersons(this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].persons);
      this.tpvServices.keyboard_screen = '';
      this.navCtrl.pop();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-selected-persons/tpv-ticket-selected-persons.ts